<template lang="pug">
.container
    nav.nav
        router-link.button__action(
            to="/products/"
            active-class="null"
        )
            i.glyphicon.glyphicon-chevron-left.icon
            | Go back
        .submit__container
            div.locales
                span(
                v-if="getActiveProduct.localRecords.length > 1"
                ) Switching locales will clear unsaved changes.
                //- span Editing Locale:
                button.button(
                :disabled="localRecord=== getActiveLocale"
                v-for="localRecord in getSortedAvailableLocales"
                value="localRecord"
                @click="changeLocale(localRecord)"
                ) {{localRecord}}
            button.button__submit(
                type="button"
                @click="save()"
            ) Save
            button.button__action(
                @click="toggleAddLocale"
            ) Add Locale
            button.button.delete-icon-button(
                v-if="getActiveProduct.active"
                @click="promptDelete()"
            )
                DeleteIcon
            div(
                    v-if="!getActiveProduct.active"
                )
                button.button__submit(
                    @click="restore()"
                ) Restore product
        </button>
    .editing__container
        .image__container
            div.header
                h1 Edit Product
            .primary__image
                label Primary Image
                .image__wrapper
                    img.image___primary(
                        v-if="getActiveLocalRecord.images && getActiveLocalRecord.images.length"
                        :src="getActiveLocalRecord.images[0]"
                    )
                    img.image___primary(
                        @click="addImage"
                        v-if="!getActiveLocalRecord.images || !getActiveLocalRecord.images.length"
                        src="/static/images/product-placeholder.png"
                    )
                    .image__editor(
                        v-if="getActiveLocalRecord.images && getActiveLocalRecord.images.length"
                    )
                        button.button__action(
                            @click="removeImage(0)"
                        ) Remove
            .image-add
                button.button__action(
                    @click="addImage(true)"
                ) Change Primary Image
        .content__container
            h1 &nbsp;
            .form__control-group
                label Name
                input(
                    class="input__text title"
                    type="text"
                    v-model="getActiveLocalRecord.name"
                )
            .form__control-group
                label Short Description
                textarea(
                    class="input__text"
                    type="text"
                    v-model="getActiveLocalRecord.shortDescription"
                    rows="5"
                )
            .form__control-group
                label Long Description
                textarea(
                    class="input__text"
                    type="text"
                    rows="7"
                    v-model="getActiveLocalRecord.longDescription"
                )
        .meta__container
            h1 &nbsp;
            .form__control-group
                label Price
                input(
                    @keypress="isNumber()"
                    class="input__text"
                    type="number"
                    v-model="getActiveLocalRecord.price"
                )
            .form__control-group
                label Retail Price
                input(
                    class="input__text"
                    @keypress="isNumber()"
                    type="number"
                    v-model="getActiveLocalRecord.retailPrice"
                )
            .form__control-group
                label SKU
                input(
                    class="input__text"
                    type="text"
                    v-model="getActiveLocalRecord.sku"
                )
            .form__control-group
                label Quantity
                input(
                    class="input__text"
                    @keypress="isNumber()"
                    type="number"
                    v-model="getActiveLocalRecord.quantity"
                )
            .form__control-group
                label Product Groups
                multiselect(
                    v-model="getActiveProduct.productGroups"
                    :options="getProductGroups"
                    placeholder="Add a Product Group"
                    :multiple="true"
                )
            .form__control-group
                label Markets
                multiselect(
                    v-model="getSortedAvailableLocales"
                    :options="getMarketsByLocale"
                    placeholder="Add a Market"
                    :multiple="true"
                )
            .form__control-group
                label Postal Codes
                vue-tags-input(
                    v-model="tag"
                    :tags="tags"
                    placeholder="Add Postal Code"
                    @tags-changed="newTags => tags = newTags"
                    :validation="postalValidation"
                    :disableAdd="false"
                )
    .image__gallery(
        v-if="getActiveLocalRecord.images && getActiveLocalRecord.images.length > 0"
    )
        label Additional product images
        button.button__action(
            @click="addImage(false)"
        ) Add More Images
        .image__grid
            .image__wrapper(
                :key="`productImage-${index}`"
                v-if="index > 0"
                v-for="(image, index) in getActiveLocalRecord.images"
            )
                .image__editor
                    button.button__action(
                        @click="removeImage(index)"
                    ) Remove
                img(
                    :src="image"
                )
</template>
<script>
import store from '../../store';
import VueNotifications from 'vue-notifications';
import Services from '../../services/Services';
import DeleteIcon from 'vue-material-design-icons/Delete';
import Multiselect from 'vue-multiselect';
import { postResource } from '../../services/Utils';
import VueTagsInput from '@johmun/vue-tags-input';
import moment from 'moment';
export default {
  name: 'ProductEditor',
  components: {
    DeleteIcon,
    Multiselect,
    VueTagsInput
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data() {
    return {
      tag: '',
      tags: [],
      postalValidation: [
        {
          classes: 'min-length',
          rule: tag => tag.text.length < 5
        },
        {
          classes: 'only-numbers',
          rule: '^[0-9]*$'
        }
      ]
    };
  },
  computed: {
    getActiveProduct: {
      get: function() {
        return store.getters.getActiveProduct;
      },
      set: function(product) {
        store.commit('setActiveProduct', product);
      }
    },
    getActiveLocale() {
      return store.getters.getActiveLocale;
    },
    getActiveLocalRecord: {
      get: function() {
        return store.getters.getActiveLocalRecord;
      },
      set: function(record) {
        store.commit('setActiveLocalRecord', record);
      }
    },
    getAllProductGroups() {
      return store.getters.getAllProductGroups;
    },
    getProductGroups() {
      if (this.getAllProductGroups) {
        let groups = [];

        this.getAllProductGroups.forEach(group => {
          let groupText = group.title;

          groups.push(groupText);
        });

        return groups;
      }
    },
    getMarkets() {
      return store.getters.getMarkets;
    },
    getSortedAvailableLocales: {
      get: function() {
        if (this.getActiveProduct && this.getActiveProduct.localRecords) {
          let locales = [];

          this.getActiveProduct.localRecords.forEach(locale => {
            locales.push(locale.locale);
          });

          return locales.sort((a, b) => a.name - b.name).reverse();
        }
      },
      set: function(newLocales) {
        let activeProduct = { ...this.getActiveProduct };
        activeProduct.markets = newLocales;
        store.commit('setActiveProduct', activeProduct);
        if (
          activeProduct.localRecords &&
          newLocales.length > activeProduct.localRecords.length
        ) {
          store.commit('showCreateProductLocalRecordModal', true);
        }
      }
    },
    getMarketsByLocale() {
      if (this.getMarkets) {
        let marketsByLocale = [];

        this.getMarkets.forEach(market => {
          marketsByLocale.push(market.locale);
        });

        return marketsByLocale;
      }
    }
  },
  methods: {
    initializeProduct(edited) {
      const product = this.getActiveProduct;

      if (!product._id) {
        this.showErrorMsg({ message: 'No matching product found' });
        this.$router.push('/products/');
      }

      // initialize default locale when we have the product record, but don't reset the active locale if we're already editing
      if (!edited) {
        if (product.fallbackLocale) {
          store.commit('setActiveLocale', product.fallbackLocale);
        } else if (product.localRecords) {
          store.commit('setActiveLocale', product.localRecords[0].locale);
        }
      }

      const activeContent =
        product.localRecords && product.localRecords.length === 1
          ? product.localRecords[0].content
          : product.localRecords.filter(record => {
              return record.locale === this.getActiveLocale;
            })[0].content || {};

      if (product.productGroups && !edited) {
        let groups = [];

        product.productGroups.forEach(group => {
          const groupName = this.getAllProductGroups.find(
            product => product._id === group
          ).title;

          groups.push(groupName);
        });

        this.getActiveProduct.productGroups = groups;
      }

      if (activeContent) {
        store.commit('setActiveLocalRecord', activeContent);
        this.tags = activeContent.postalCodes;
      } else {
        store.commit('setActiveLocalRecord', {});
      }
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    addImage(isPrimary) {
      if (isPrimary) {
        store.commit('setIsPrimaryImage', true);
      } else {
        store.commit('setIsPrimaryImage', false);
      }
      store.commit('showUploadProductImageModal', true);
    },
    removeImage(index) {
      console.log('remove slice', index);
      const activeContent = { ...this.getActiveLocalRecord };
      const currentImages = activeContent.images;

      currentImages.splice(index, 1);
    },
    changeLocale(locale) {
      console.log(locale);
      store.commit('setActiveLocale', locale);
      this.initializeProduct(true);
    },
    toggleAddLocale() {
      store.commit('showCreateProductLocalRecordModal', true);
    },
    save() {
      const update = this.getActiveProduct;
      const contentUpdate = this.getActiveLocalRecord;
      update.content = contentUpdate;

      const productGroupIds = [];
      update.productGroups.forEach(group => {
        const groupId = this.getAllProductGroups.find(
          product => product.name === group.name
        )._id;
        productGroupIds.push(groupId);
      });

      update.productGroups = productGroupIds;

      const postalCodes = [];

      for(let i = 0; i < this.tags.length; i++) {
          const tag = this.tags[i];
          if(tag.tiClasses.indexOf('ti-invalid') === -1 ){
              postalCodes.push(tag.text);

          }
      }

      update.content.postalCodes = postalCodes;

      postResource(
        '/v1/products/update',
        `id=${this.getActiveProduct._id}&locale=${encodeURIComponent(
          this.getActiveLocale
        )}`,
        update
      )
        .then(res => {
          console.log(res);
          // return  Services.setActiveProduct(productId, this.initializeProduct(true));
        })
        .then(() => {
          this.showSuccessMsg({
            message: `${this.getActiveLocale} product saved!`
          });
        })
        .catch(error => {
          this.showSuccessMsg({
            message: `${this.getActiveLocale} product saved!`
          });
        });
    },
    promptDelete() {
      store.commit('showDeleteProductModal', true);
    },
    restore() {
      store.commit('showRestoreProductModal', true);
    }
  },
  mounted() {
    const productId = this.$route.params.productId;

    if (!productId) {
      this.showErrorMsg({ message: 'No matching product found' });
      this.$router.push('/products/');
    }

    Services.setActiveProduct(productId, this.initializeProduct);
    if (!store.getters.getMarkets.length) {
      Services.getMarkets();
    }
  },
  beforeDestroy() {
    store.commit('setIsPrimaryImage', false);
    Services.clearActiveProduct();
    Services.clearActiveRecords();
  }
};
</script>
<style lang="scss" scoped>
.image__editor {
  opacity: 0;
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image__wrapper {
  position: relative;

  &:hover {
    .image__editor {
      opacity: 1;
    }
  }
}
.button__submit {
  padding: 8px 32px;
  width: auto;
  margin-left: 25px;
}

.image-add {
  margin: 1rem 0;
}

.image___primary {
  display: block;
  margin-top: 8px;
}

.editing__container {
  display: flex;
  padding: 2rem;
  margin-top: 2rem;
  width: 100%;

  .form__control-group {
    margin-bottom: 0.625rem;
  }

  input,
  textarea {
    width: 100%;

    &.title {
      max-width: 630px;
    }
  }

  .image__container,
  .meta__container {
    width: 33.33%;

    .button__action {
      margin: 1rem 0;
    }

    .primary__image img {
      height: auto;
      max-width: 100%;
    }
  }

  .content__container {
    width: 100%;
  }

  .content__container,
  .meta__container {
    padding-left: 2.6rem;
  }

  @media all and (max-width: 640px) {
    flex-direction: column;

    .image__container,
    .content__container,
    .meta__container {
      padding-left: 0;
      width: 100%;
    }
  }
}

.image__gallery {
  padding: 0 2rem;

  .button__action {
    margin: 1rem 0;
  }

  .image__grid {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;

    .image__wrapper {
      margin: 1rem 0.5rem;
      height: auto;
      max-width: 20%;

      img {
        height: auto;
        width: 100%;
      }

      &:first-child {
        margin-left: 0;
      }
    }
  }
}

.form__control-group {
  label {
    display: block;
    margin-bottom: 5px;
  }
}

.delete-icon-button {
  cursor: pointer;
  border: 1px solid #eb4d4b;
  background: #fff;
  white-space: nowrap;
  text-overflow: ellipsis;
  opacity: 1;
  pointer-events: auto;
  font-size: 0.9em;
  color: #eb4d4b;
  border-radius: 5px;
  padding: 8px 9px;
  margin: auto 0 auto 10px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  cursor: pointer;

  &:hover {
    border-color: darken(#eb4d4b, 15%);
    color: darken(#eb4d4b, 15%);
  }
}

.header {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/views/ProductEditor.vue